var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 60,
    viewBox: "0 0 63 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_tot_progetti",
    "data-name": "icona tot progetti",
    transform: "translate(-1077.252 -747.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icona_cartella",
    "data-name": "icona cartella",
    d: "M62,51.7a5.9,5.9,0,0,1-5.9,5.9H8.9A5.9,5.9,0,0,1,3,51.7V10.4A5.9,5.9,0,0,1,8.9,4.5H23.65l5.9,8.85H56.1a5.9,5.9,0,0,1,5.9,5.9Z",
    transform: "translate(1076.252 746.502)",
    fill: "none",
    stroke: "#d6d6d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_789",
    "data-name": "Rettangolo 789",
    transform: "translate(1078.752 747.502)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.8299e1035060658d380bf7b8b13f1130.svg";
export { ForwardRef as ReactComponent };